// ** Redux Imports
import { createSlice } from '@reduxjs/toolkit'

// ** UseJWT import to get config
import useJwt from '@src/auth/jwt/useJwt'

const config = useJwt.jwtConfig

const initialUser = () => {
  const item = window.localStorage.getItem('userData')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : {}
}

//20220610 Comentario
//se quito la funcion JSON.stringify de las lineas 29 y 30
//que que al usar JSON agregaba el caracter " al inicio y al fina

export const authSlice = createSlice({
  name: 'authentication',
  initialState: {
    userData: initialUser()
  },
  reducers: {
    handleLogin: (state, action) => {
      state.userData = action.payload
      state[config.storageTokenKeyName] = action.payload[config.storageTokenKeyName]
      state[config.storageRefreshTokenKeyName] = action.payload[config.storageRefreshTokenKeyName]

      localStorage.setItem('userData', JSON.stringify(action.payload))
      localStorage.setItem(config.storageTokenKeyName, action.payload.accessToken)
      localStorage.setItem(config.storageRefreshTokenKeyName, action.payload.refreshToken)      
    },
    handleLogout: state => {
      state.userData = {}
      state[config.storageTokenKeyName] = null
      state[config.storageRefreshTokenKeyName] = null
      // ** Remove user, accessToken & refreshToken from localStorage
      localStorage.removeItem('userData')
      localStorage.removeItem(config.storageTokenKeyName)
      localStorage.removeItem(config.storageRefreshTokenKeyName)

      localStorage.removeItem("valorIdCommission", "")
      localStorage.removeItem("dataExecutive")
      localStorage.removeItem("dataManager")
      localStorage.removeItem("dataCharge")
      localStorage.removeItem("dataPayment")
      localStorage.removeItem("dataKpi")
      localStorage.removeItem("dataKpis")
      localStorage.removeItem("dataKeyloan")
      localStorage.removeItem("dataKpisDetail")
      localStorage.removeItem("dataComission")
      localStorage.removeItem("dataProspection")
      localStorage.removeItem("dataAttendance")
      localStorage.removeItem("dataMeeting")
      localStorage.removeItem("dataEquipmentLoan")
      localStorage.removeItem("dataPublication")
      localStorage.removeItem("dataFeepayments")
      localStorage.removeItem("dataAssistanceOffice")
      localStorage.removeItem("dataComissionMasterVer")
      localStorage.removeItem("dataComissionMasterUni")
      localStorage.removeItem("dataUnifiedInvoice")
      localStorage.removeItem("dataDashboards")
      localStorage.removeItem("datakpisConfig")
      localStorage.removeItem("dataOffice")
      localStorage.removeItem("dataDashboardsGlobal")
      localStorage.removeItem("resetKpis")
      localStorage.removeItem("resetKpisDetail")
      localStorage.removeItem("resetDashboards")
      localStorage.removeItem("resetDashboardsGlobal")
      localStorage.removeItem("dataAllClosure")
    }
  }
})

export const { handleLogin, handleLogout } = authSlice.actions

export default authSlice.reducer
